import { formatInTimeZone } from 'date-fns-tz';
import {
  DATE_FORMAT_DAY_TIME,
  DATE_FORMAT_DAY_TIME_WITH_YEAR,
} from '@/shared/config';

const UTC_SUFFIX_REGEX = /(Z|[+-]\d{2}:?\d{2})$/;

const toUtcDateString = (value: string) =>
  UTC_SUFFIX_REGEX.test(value) ? value : `${value}Z`;

const formatInvoiceDate = (value?: string | null) => {
  if (!value) return null;

  const date = new Date(toUtcDateString(value));

  if (Number.isNaN(date.getTime())) return null;

  const isCurrentYear = date.getUTCFullYear() === new Date().getUTCFullYear();

  return formatInTimeZone(
    date,
    'UTC',
    isCurrentYear ? DATE_FORMAT_DAY_TIME : DATE_FORMAT_DAY_TIME_WITH_YEAR
  );
};

export { formatInvoiceDate };
